import { Component, Input } from '@angular/core';
import { IMAGE_SRC } from '../../../shared-constants';

@Component({
  selector: 'app-table-sorting-box',
  templateUrl: './table-sorting-box.component.html',
  styleUrls: ['./table-sorting-box.component.scss'],
  standalone: false,
})
export class TableSortingBoxComponent {
  @Input() sortAddedAsc!: boolean;
  @Input() title!: string;
  @Input() rightAlign = false;
  @Input() width = 146;
  @Input() customClass = '';
  readonly IMAGE_SRC = IMAGE_SRC;
}
